declare namespace $ {

	type __shm_hitalama_map_book_1 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_book['widget_headers_visible'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_book['Head'] >['widget_headers_visible'] >[0]
	>
	type __shm_hitalama_map_book_2 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_book['widget_list_visible'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_book['Head'] >['widget_list_visible'] >[0]
	>
	type __shm_hitalama_map_book_3 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_book['rights_visible'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_book['Head'] >['rights_visible'] >[0]
	>
	type __shm_hitalama_map_book_4 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_book['drawing_tools_visible'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_book['Head'] >['drawing_tools_visible'] >[0]
	>
	type __shm_hitalama_map_book_5 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_book['file_list_visible'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_book['Head'] >['file_list_visible'] >[0]
	>
	type __shm_hitalama_map_book_6 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_book['editor_mode_enabled'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_book['Head'] >['editor_mode_enabled'] >[0]
	>
	type __shm_hitalama_map_book_7 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_book['arrows_visible'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_book['Head'] >['arrows_visible'] >[0]
	>
	type $shm_hitalama_map_head__map_shm_hitalama_map_book_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['map'] >
		,
		ReturnType< $shm_hitalama_map_head['map'] >
	>
	type $shm_hitalama_map_head__zoom_shm_hitalama_map_book_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['zoom'] >
		,
		ReturnType< $shm_hitalama_map_head['zoom'] >
	>
	type $shm_hitalama_map_head__shift_shm_hitalama_map_book_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['shift'] >
		,
		ReturnType< $shm_hitalama_map_head['shift'] >
	>
	type $shm_hitalama_map_head__map_cut_shm_hitalama_map_book_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['map_cut'] >
		,
		ReturnType< $shm_hitalama_map_head['map_cut'] >
	>
	type $shm_hitalama_map_head__history_open_shm_hitalama_map_book_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['history_open'] >
		,
		ReturnType< $shm_hitalama_map_head['history_open'] >
	>
	type $shm_hitalama_map_book_widgets3__map_shm_hitalama_map_book_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['map'] >
		,
		ReturnType< $shm_hitalama_map_book_widgets3['map'] >
	>
	type $shm_hitalama_map_book_widgets3__Map_page_shm_hitalama_map_book_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_book_widgets3['Map_page'] >
	>
	type $shm_hitalama_map_book_widgets3__editor_mode_enabled_shm_hitalama_map_book_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['editor_mode_enabled'] >
		,
		ReturnType< $shm_hitalama_map_book_widgets3['editor_mode_enabled'] >
	>
	type $shm_hitalama_map_book_widgets3__widget_list_visible_shm_hitalama_map_book_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['widget_list_visible'] >
		,
		ReturnType< $shm_hitalama_map_book_widgets3['widget_list_visible'] >
	>
	type __shm_hitalama_map_book_17 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_book['zoom'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_book['Map_page'] >['zoom'] >[0]
	>
	type __shm_hitalama_map_book_18 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_book['shift'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_book['Map_page'] >['shift'] >[0]
	>
	type __shm_hitalama_map_book_19 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_book['go_to_widget'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_book['Map_page'] >['go_to_widget'] >[0]
	>
	type __shm_hitalama_map_book_20 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_book['Widget'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_book['Map_page'] >['Widget'] >[0]
	>
	type $shm_hitalama_map_page__entity_shm_hitalama_map_book_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['entity'] >
		,
		ReturnType< $shm_hitalama_map_page['entity'] >
	>
	type $shm_hitalama_map_page__cut_shm_hitalama_map_book_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['map_cut'] >
		,
		ReturnType< $shm_hitalama_map_page['cut'] >
	>
	type $shm_hitalama_map_page__widget_headers_visible_shm_hitalama_map_book_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['widget_headers_visible'] >
		,
		ReturnType< $shm_hitalama_map_page['widget_headers_visible'] >
	>
	type $shm_hitalama_map_page__arrows_visible_shm_hitalama_map_book_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['arrows_visible'] >
		,
		ReturnType< $shm_hitalama_map_page['arrows_visible'] >
	>
	type $shm_hitalama_map_page__tool_mode_shm_hitalama_map_book_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['tool_mode'] >
		,
		ReturnType< $shm_hitalama_map_page['tool_mode'] >
	>
	type $shm_hitalama_map_page__Widget_props_shm_hitalama_map_book_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['Widget_props'] >
		,
		ReturnType< $shm_hitalama_map_page['Widget_props'] >
	>
	type $shm_hitalama_map_book_tools_float__Map_page_shm_hitalama_map_book_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_book_tools_float['Map_page'] >
	>
	type $shm_hitalama_map_book_tools_float__tool_mode_shm_hitalama_map_book_28 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['tool_mode'] >
		,
		ReturnType< $shm_hitalama_map_book_tools_float['tool_mode'] >
	>
	type $shm_hitalama_map_editor__map_shm_hitalama_map_book_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['map'] >
		,
		ReturnType< $shm_hitalama_map_editor['map'] >
	>
	type $shm_hitalama_map_editor__widget_shm_hitalama_map_book_30 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['widget_for_editor'] >
		,
		ReturnType< $shm_hitalama_map_editor['widget'] >
	>
	type $shm_hitalama_map_editor__Widget_shm_hitalama_map_book_31 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['Widget'] >
		,
		ReturnType< $shm_hitalama_map_editor['Widget'] >
	>
	type $shm_hitalama_map_book_page__map_id_shm_hitalama_map_book_32 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['map_context'] >
		,
		ReturnType< $shm_hitalama_map_book_page['map_id'] >
	>
	type $shm_hitalama_map_book_page__title_shm_hitalama_map_book_33 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['title'] >
		,
		ReturnType< $shm_hitalama_map_book_page['title'] >
	>
	type $shm_hitalama_map_book_page__sub_shm_hitalama_map_book_34 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['page_sub'] >
		,
		ReturnType< $shm_hitalama_map_book_page['sub'] >
	>
	type $shm_hitalama_map_widget_page__widget_shm_hitalama_map_book_35 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['widget_for_settings'] >
		,
		ReturnType< $shm_hitalama_map_widget_page['widget'] >
	>
	type $shm_hitalama_map_widget_page__Map_page_shm_hitalama_map_book_36 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_widget_page['Map_page'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_book_37 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_book_38 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['rights_close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_book_39 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $shm_hitalama_map_rights__map_shm_hitalama_map_book_40 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['map'] >
		,
		ReturnType< $shm_hitalama_map_rights['map'] >
	>
	type $shm_hitalama_map_rights__team_shm_hitalama_map_book_41 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['rights_team'] >
		,
		ReturnType< $shm_hitalama_map_rights['team'] >
	>
	type $shm_hitalama_map_book_tools__tool_mode_shm_hitalama_map_book_42 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['tool_mode'] >
		,
		ReturnType< $shm_hitalama_map_book_tools['tool_mode'] >
	>
	type $shm_hitalama_map_book_tools__style_shm_hitalama_map_book_43 = $mol_type_enforce<
		({ 
			'left': ReturnType< $shm_hitalama_map_book['tool_modes_left'] >,
		}) 
		,
		ReturnType< $shm_hitalama_map_book_tools['style'] >
	>
	type $shm_hitalama_map_widget_presets_page__Map_page_shm_hitalama_map_book_44 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_widget_presets_page['Map_page'] >
	>
	type $shm_hitalama_resilience_page__title_shm_hitalama_map_book_45 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_resilience_page['title'] >
	>
	type $shm_hitalama_resilience_page__message_shm_hitalama_map_book_46 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_resilience_page['message'] >
	>
	type $shm_hitalama_resilience_page__retry_visible_shm_hitalama_map_book_47 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_hitalama_resilience_page['retry_visible'] >
	>
	type $shm_hitalama_resilience_page__title_shm_hitalama_map_book_48 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['failure_title'] >
		,
		ReturnType< $shm_hitalama_resilience_page['title'] >
	>
	type $shm_hitalama_resilience_page__message_shm_hitalama_map_book_49 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['failure_message'] >
		,
		ReturnType< $shm_hitalama_resilience_page['message'] >
	>
	type $shm_hitalama_resilience_page__details_shm_hitalama_map_book_50 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['failure_details'] >
		,
		ReturnType< $shm_hitalama_resilience_page['details'] >
	>
	type $shm_hitalama_resilience_page__retry_visible_shm_hitalama_map_book_51 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['failure_retry_visible'] >
		,
		ReturnType< $shm_hitalama_resilience_page['retry_visible'] >
	>
	type $mol_check_icon__checked_shm_hitalama_map_book_52 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['widget_list_visible'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check_icon__Icon_shm_hitalama_map_book_53 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['Widgets_visible_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_page__title_shm_hitalama_map_book_54 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_shm_hitalama_map_book_55 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_shm_hitalama_map_book_56 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	export class $shm_hitalama_map_book extends $mol_book2 {
		title( ): string
		map_context( ): string
		map_cut( ): any
		widget_headers_visible( next?: ReturnType< ReturnType< $shm_hitalama_map_book['Head'] >['widget_headers_visible'] > ): ReturnType< ReturnType< $shm_hitalama_map_book['Head'] >['widget_headers_visible'] >
		widget_list_visible( next?: ReturnType< ReturnType< $shm_hitalama_map_book['Head'] >['widget_list_visible'] > ): ReturnType< ReturnType< $shm_hitalama_map_book['Head'] >['widget_list_visible'] >
		rights_visible( next?: ReturnType< ReturnType< $shm_hitalama_map_book['Head'] >['rights_visible'] > ): ReturnType< ReturnType< $shm_hitalama_map_book['Head'] >['rights_visible'] >
		drawing_tools_visible( next?: ReturnType< ReturnType< $shm_hitalama_map_book['Head'] >['drawing_tools_visible'] > ): ReturnType< ReturnType< $shm_hitalama_map_book['Head'] >['drawing_tools_visible'] >
		file_list_visible( next?: ReturnType< ReturnType< $shm_hitalama_map_book['Head'] >['file_list_visible'] > ): ReturnType< ReturnType< $shm_hitalama_map_book['Head'] >['file_list_visible'] >
		editor_mode_enabled( next?: ReturnType< ReturnType< $shm_hitalama_map_book['Head'] >['editor_mode_enabled'] > ): ReturnType< ReturnType< $shm_hitalama_map_book['Head'] >['editor_mode_enabled'] >
		arrows_visible( next?: ReturnType< ReturnType< $shm_hitalama_map_book['Head'] >['arrows_visible'] > ): ReturnType< ReturnType< $shm_hitalama_map_book['Head'] >['arrows_visible'] >
		Head( ): $shm_hitalama_map_head
		Widgets( ): $shm_hitalama_map_book_widgets3
		widget_list_view( ): readonly(any)[]
		entity( ): $giper_baza_entity
		map( ): ReturnType< ReturnType< $shm_hitalama_map_book['Map_page'] >['map'] >
		zoom( next?: ReturnType< ReturnType< $shm_hitalama_map_book['Map_page'] >['zoom'] > ): ReturnType< ReturnType< $shm_hitalama_map_book['Map_page'] >['zoom'] >
		shift( next?: ReturnType< ReturnType< $shm_hitalama_map_book['Map_page'] >['shift'] > ): ReturnType< ReturnType< $shm_hitalama_map_book['Map_page'] >['shift'] >
		widgets_filtered( ): ReturnType< ReturnType< $shm_hitalama_map_book['Map_page'] >['widgets_filtered'] >
		selected_links( ): ReturnType< ReturnType< $shm_hitalama_map_book['Map_page'] >['selected_links'] >
		go_to_widget( id: any): ReturnType< ReturnType< $shm_hitalama_map_book['Map_page'] >['go_to_widget'] >
		Widget( id: any): ReturnType< ReturnType< $shm_hitalama_map_book['Map_page'] >['Widget'] >
		Map_page( ): $shm_hitalama_map_page
		Floating_tools( ): $shm_hitalama_map_book_tools_float
		widget_for_editor( ): any
		Editor( ): $shm_hitalama_map_editor
		map_or_editor( ): readonly(any)[]
		page_sub( ): readonly(any)[]
		Page( ): $shm_hitalama_map_book_page
		widget_for_settings( ): any
		Widget_props( ): $shm_hitalama_map_widget_page
		widget_props_visible( ): readonly(any)[]
		tool_mode( next?: string ): string
		tool_modes_left( ): string
		failure_title( id: any): string
		failure_message( id: any): string
		failure_details( id: any): string
		failure_retry_visible( id: any): boolean
		Widgets_visible_icon( ): $mol_icon_format_list_bulleted
		rights_close( next?: any ): any
		Rights_close_icon( ): $mol_icon_close
		Rights_close( ): $mol_button_minor
		rights_team( next?: any ): any
		Rights_form( ): $shm_hitalama_map_rights
		placeholders( ): readonly(any)[]
		menu_title( ): ReturnType< $shm_hitalama_map_book['title'] >
		history_open( next?: any ): any
		pages( ): readonly(any)[]
		Tool_modes( ): $shm_hitalama_map_book_tools
		Presets_page( ): $shm_hitalama_map_widget_presets_page
		Access_denied( ): $shm_hitalama_resilience_page
		Failure_page( id: any): $shm_hitalama_resilience_page
		Widgets_visible( ): $mol_check_icon
		Rights( ): $mol_page
	}
	
}

//# sourceMappingURL=book.view.tree.d.ts.map